<template lang="pug">
app-card
  app-card-header 
    app-card-title {{ region.title }}
  app-card-body
    app-card-caption
      card-row-label-value(label="Алиас региона" :value="region.alias")
      card-row-label-value(label="Код региона" :value=" region.code")
</template>

<script>
import CardRowLabelValue from '../components/CardRowLabelValue.vue'

export default {
  name: "ExpertRegionCard",

  components: {
    CardRowLabelValue
  },

  props: {
    region : null
  }
}
</script>